module.exports = __webpack_public_path__ + "static/img/__1264.7555477.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1264.jpg
// module id = /R5Z
// module chunks = 0